import React, { Component } from 'react';
import { getDateProp } from '../global/utils';
import { makeBEM } from '../global/utils';
import DragScroll from './DragScroll';
import { HabitDates } from '../models/habit-dates';

const maxDates = 5;
const renderMonthAddYear = true;
const NUMBER_OF_DATES_TO_RENDER = 27;

class HabitDatesModule extends Component {

	constructor(props) {
		super(props);

		this.state = {
			parentID: this.props.parentID,
			dates: this.props.dates,
			datesLength: this.props.dates.length,
			seenMonths: [],
			habitDates: new HabitDates(this.props.parentID, this.props.dates),
		};

		this.moduleName = 'habit-dates';
	}

	componentWillReceiveProps(nextProps) {
		const habitDates = this.state.habitDates;

		if ( habitDates ) {
			habitDates.setDates(nextProps.dates);
		}

		this.setState({ 
			dates: nextProps.dates, 
			datesLength: nextProps.dates.length,
			seenMonths: [], 
			habitDates: habitDates,
		}); 
	}

	seenMonth(date) {
		var year = getDateProp(date, 'year');
		var month = getDateProp(date, 'month');
		var key = year + "_" + month;
	
		return ( typeof this.state.seenMonths[key] != 'undefined' );		
	}

	renderMonth(date) {
		const year = getDateProp(date, 'year');
		const yearString = year.toString();
		const yearLastTwoDigits = yearString.substr(-2)
		const month = getDateProp(date, 'month');
		let toReturn = getDateProp(date, 'monthName');
		toReturn = toReturn.substr(0, 3);
		
		if ( renderMonthAddYear ) {
			toReturn += " " + yearLastTwoDigits;
		}

		var key = year + "_" + month;
	
		if ( !this.seenMonth(date) ) {
			this.state.seenMonths[key] = true;
		} else {
			toReturn = "";
		}

		return toReturn;
	}

	calculateStyle() {
		var divStyle = {};

		var index = 2;
		index = this.state.datesLength > maxDates ? (this.state.datesLength - maxDates)  : 0;
		
		var transformValue = "translateX(calc(-36 * "  + index + "px))";
		


		if ( index !== 0  ) {
			divStyle = {transform: transformValue};
		}
		return divStyle;
	}

	getMonthYearClass() {
		return `${ makeBEM('streak-date', `month`) }
				${ renderMonthAddYear ? "month year" : "month" }`;
	}

	renderDate(date, key, streak=true) {
		const modifier = streak ? '' : 'streak-date--no-streak';
		return (
			<div 
				className={`streak-date ${ makeBEM(this.moduleName, 'streak-date') } ${modifier}` }
				key={key}>
				{
					<div 
						className={ this.getMonthYearClass() }
					>
						{this.renderMonth(date)}
					</div>
				}
				<div className={`day ${ makeBEM('streak-date', 'day') }` }>
					{getDateProp(date, 'day')}
				</div>
			</div>
		)
	}

	render() {
		// How to bundle them since we are looping to individual dates ?
		const habitDates = this.state.habitDates;
		const dates = habitDates.getDates();
		return (
			<DragScroll>
				<div className={`streak-dates ${ this.moduleName }`}>
					{
						dates &&
						Object.keys(dates).map(key => (

							key < NUMBER_OF_DATES_TO_RENDER ?
							this.renderDate(
									dates[key],
									key, 
									habitDates.dateInAStreak(dates[key])
							)
							: ''
							
						))
					}
				</div>
			</DragScroll>
		)
	}
}

export default HabitDatesModule;